import { makeStyles } from 'tss-react/mui'

export const useStyles = makeStyles()(theme => ({
  dimensionBox: {
    paddingBottom: `${theme.spacing(3)} !important`,
  },
  dimensionWrapper: {
    paddingTop: theme.spacing(3),
    width: '100%',
  },
}))
